module.exports = __webpack_public_path__ + "img/로드메이지.a91238b2.png";